/* Product hidden-UI and quick-add interaction loader. */
(function (window, document) {
  'use strict';

  var loaderScript = document.currentScript || document.querySelector('script[data-verychi-product-cqa-loader]');
  if (!loaderScript) return;

  var quickAddSrc = loaderScript.getAttribute('data-verychi-cqa-src') || '';
  var sectionId = loaderScript.getAttribute('data-verychi-product-section-id') || '';
  var config = {};
  var configNode = document.getElementById('VerychiProductRuntimeConfig');
  if (configNode) {
    try { config = JSON.parse(configNode.textContent || '{}'); } catch (error) {}
  }

  if (quickAddSrc && (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost')) {
    try {
      var quickAddUrl = new URL(quickAddSrc, window.location.href);
      quickAddSrc = quickAddUrl.pathname + quickAddUrl.search;
    } catch (error) {}
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function appendHtml(html) {
    var template = document.createElement('template');
    template.innerHTML = html;
    document.body.appendChild(template.content);
  }

  function ensureCqaUi() {
    if (document.getElementById('CqaPopup')) return;

    appendHtml(
      '<div class="cqa-overlay" id="CqaOverlay" style="display:none"></div>' +
      '<div class="cqa-popup" id="CqaPopup" style="visibility:hidden" data-txt-empty="Няма налични размери" data-txt-added="Добавено в кошницата" data-txt-soldout="Изчерпан" data-txt-error="Грешка" data-txt-low-stock="Последни бройки" data-low-stock-threshold="2" data-txt-notify="Уведомете ме при наличност" data-txt-add-single="+ Добави" data-color-map="">' +
        '<div class="cqa-popup__handle"><span></span></div>' +
        '<div class="cqa-popup__header cqa-popup__title" style="order:var(--cqa-popup-order-title,1); display:flex; justify-content:space-between; align-items:flex-start; gap:10px;">' +
          '<div id="CqaPopupTitle" style="flex:1; padding-right:15px;"></div>' +
          '<div style="display:flex; align-items:flex-start; gap:12px; flex-shrink:0;">' +
            '<button type="button" class="wl-card-btn" id="CqaWishlistBtn" data-wl-handle="" data-wl-color="" data-wl-title="" data-wl-img="" data-wl-url="" data-wl-price="" aria-label="Любими" style="padding:4px;">' +
              '<svg class="wl-icon-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="width:20px;height:20px;"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>' +
              '<svg class="wl-icon-filled" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5" style="width:20px;height:20px;"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>' +
            '</button>' +
            '<button type="button" id="CqaPopupClose" style="background:none;border:none;font-size:24px;cursor:pointer;color:var(--cqa-popup-title-color);padding:0;line-height:1;margin-top:-4px;" aria-label="Затвори">&times;</button>' +
          '</div>' +
        '</div>' +
        '<div class="cqa-popup__price" id="CqaPopupPrice" style="order:var(--cqa-popup-order-price,2)"></div>' +
        '<div class="cqa-popup__carousel" id="CqaPopupCarousel" style="order:var(--cqa-popup-order-carousel,3)"></div>' +
        '<div class="cqa-popup__color-group" style="order:var(--cqa-popup-order-colors,4)">' +
          '<div class="cqa-popup__label" id="CqaColorLabel" style="display:none;">ЦВЯТ</div>' +
          '<div class="cqa-popup__colors" id="CqaPopupColors"></div>' +
        '</div>' +
        '<div class="cqa-popup__divider" style="order:var(--cqa-popup-order-colors,4)"></div>' +
        '<a class="cqa-popup__size-guide-link" id="CqaSizeGuideTop" href="#" style="order:var(--cqa-popup-order-guide,6)">размери</a>' +
        '<div class="cqa-popup__size-group" style="order:var(--cqa-popup-order-sizes,5)">' +
          '<div class="cqa-popup__label cqa-popup__label--size">Изберете размер</div>' +
          '<div class="cqa-panel" id="CqaSizePanel"><div class="cqa-panel__body" id="CqaPanelBody"><div id="CqaPopupSizes"></div></div></div>' +
        '</div>' +
      '</div>' +
      '<div class="cqa-size-guide-overlay" id="CqaSizeGuideOverlay"></div>' +
      '<div class="cqa-size-guide-modal cqa-size-guide-modal--dynamic" id="CqaSizeGuideModal">' +
        '<button class="cqa-size-guide-modal__close" id="CqaSizeGuideClose">&times;</button>' +
        '<div class="cqa-size-guide-modal__inner" id="CqaSizeGuideModalInner" data-size-guide-mode="default-pending"></div>' +
      '</div>' +
      '<template id="DefaultSizeGuideData"></template>' +
      '<div class="cqa-inquiry" id="CqaInquiryPanel">' +
        '<div class="cqa-inquiry__header"><span class="cqa-inquiry__title">Уведомете ме при наличност</span><button class="cqa-inquiry__close" id="CqaInquiryClose">&times;</button></div>' +
        '<form id="CqaInquiryForm" action="/contact" method="post">' +
          '<input type="hidden" name="form_type" value="contact">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[Intent]" value="Уведомете ме при наличност">' +
          '<input type="hidden" name="contact[subject]" id="CqaInquirySubject" value="">' +
          '<input type="hidden" name="contact[ProductName]" id="CqaInquiryProductName" value="">' +
          '<input type="hidden" name="contact[Color]" id="CqaInquiryColor" value="">' +
          '<input type="hidden" name="contact[Size]" id="CqaInquirySize" value="">' +
          '<input type="hidden" name="contact[SKU]" id="CqaInquirySKU" value="">' +
          '<input type="hidden" name="contact[Price]" id="CqaInquiryPrice" value="">' +
          '<input type="hidden" name="contact[ProductURL]" id="CqaInquiryProduct" value="">' +
          '<input type="hidden" name="contact[body]" id="CqaInquiryBody" value="">' +
          '<input type="email" name="contact[email]" id="CqaInquiryEmail" class="cqa-inquiry__email" placeholder="Имейл адрес" required>' +
          '<button type="submit" class="cqa-inquiry__submit">ИЗПРАТИ</button>' +
        '</form>' +
        '<div class="cqa-inquiry__success" id="CqaInquirySuccess" style="display:none">Благодарим! Ще ви уведомим при наличност.</div>' +
      '</div>' +
      '<div class="cqa-toast" id="CqaToast" style="opacity:0;pointer-events:none"></div>'
    );
  }

  function ensureProductRequestUi() {
    if (document.getElementById('product-request')) return;

    var productUrl = config.productUrl || '';
    var currentVariantUrl = config.currentVariantUrl || productUrl;
    var productName = config.currentVariantProductName || config.productTitle || '';
    var currentVariantTitle = config.currentVariantTitle || '';
    var selectedVariantId = '';
    var selectedVariantNode = document.getElementById('ProductSelect');
    if (selectedVariantNode) selectedVariantId = String(selectedVariantNode.value || '');
    if (selectedVariantId) {
      try {
        var productJsonNode = document.getElementById('ProductJson-' + sectionId);
        var productJson = JSON.parse(productJsonNode ? (productJsonNode.textContent || '{}') : '{}');
        (productJson.variants || []).some(function (variant) {
          if (String(variant.id) !== selectedVariantId) return false;
          currentVariantUrl = productUrl + '?variant=' + variant.id;
          currentVariantTitle = variant.public_title || variant.title || '';
          productName = (config.productTitle || '') + ' / ' + currentVariantTitle + ' - ' +
            (variant.price / 100).toFixed(2) + ' € / ' + (variant.price / 100 * 1.95583).toFixed(2) + ' лв';
          return true;
        });
      } catch (error) {}
    }

    appendHtml(
      '<div id="product-request" class="mfp-hide popup-che product-request-modal">' +
        '<div class="product-request-modal__header">' +
          '<button type="button" class="product-request-modal__back js-product-request-close" aria-label="Затвори"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"></path></svg></button>' +
          '<h2 class="product-request-modal__title">' + escapeHtml(config.notifyTitle || 'ПОЛУЧИ ИЗВЕСТИЕ') + '</h2>' +
        '</div>' +
        '<p class="product-request-modal__subtitle">' + escapeHtml(config.notifySubtitle || '') + '</p>' +
        '<div class="form-vertical">' +
          '<form method="post" action="/contact#ProductRequestContactForm" id="ProductRequestContactForm" accept-charset="UTF-8" class="contact-form">' +
            '<input type="hidden" name="form_type" value="contact">' +
            '<input type="hidden" name="utf8" value="✓">' +
            '<input type="hidden" id="ContactFormIntentRequest" name="contact[Intent]" value="Запитване за изчерпан продукт">' +
            '<input type="hidden" id="ContactFormSubjectRequest" name="contact[subject]" value="' + escapeHtml(config.notifySubject || '') + '">' +
            '<input type="hidden" id="ContactFormProduct" class="contact-form-variant-url" name="contact[Product]" data-target="' + escapeHtml(productUrl) + '" value="' + escapeHtml(currentVariantUrl) + '">' +
            '<input type="hidden" id="ContactFormProductName" class="contact-form-product-name" name="contact[ProductName]" value="' + escapeHtml(productName) + '">' +
            '<input type="hidden" id="ContactFormVariantTitle" name="contact[VariantTitle]" value="' + escapeHtml(currentVariantTitle) + '">' +
            '<input type="hidden" id="ContactFormColor" name="contact[Color]" value="">' +
            '<input type="hidden" id="ContactFormSize" name="contact[Size]" value="">' +
            '<input type="hidden" id="ContactFormSelectedOptions" name="contact[SelectedOptions]" value="">' +
            '<input type="hidden" id="ContactFormAllOptionValues" name="contact[AllOptionValues]" value="">' +
            '<input type="hidden" id="ContactFormName" name="contact[name]" value="' + escapeHtml(config.contactName || 'Verychi Visitor') + '">' +
            '<input type="hidden" id="ContactFormMessage" name="contact[body]" value="Искам известие при наличност.">' +
            '<div class="product-request-modal__field">' +
              '<label for="ContactFormEmail" class="hidden-label">Имейл</label>' +
              '<input type="email" id="ContactFormEmail" name="contact[email]" placeholder="' + escapeHtml(config.notifyEmailPlaceholder || 'Имейл') + '" autocorrect="off" autocapitalize="off" value="' + escapeHtml(config.customerEmail || '') + '" required>' +
            '</div>' +
            '<label class="product-request-modal__consent" for="ProductRequestSubscribe">' +
              '<input type="checkbox" id="ProductRequestSubscribe" name="contact[SubscribeToNewsletter]" value="1">' +
              '<span>' + escapeHtml(config.notifyConsentText || '') + '</span>' +
            '</label>' +
            '<button type="submit" class="product-request-modal__submit" id="ProductRequestSubmit">' + escapeHtml(config.notifyButtonText || 'ПОЛУЧИ ИЗВЕСТИЕ') + '</button>' +
            '<div class="product-request-modal__feedback" id="ProductRequestFeedback"></div>' +
            '<p class="product-request-modal__privacy">' + escapeHtml(config.notifyPrivacyPrefix || '') + ' ' +
              '<a href="' + escapeHtml(config.notifyPrivacyUrl || '/policies/privacy-policy') + '" target="_blank" rel="noopener">' + escapeHtml(config.notifyPrivacyLinkText || '') + '</a>' +
            '</p>' +
          '</form>' +
        '</div>' +
      '</div>'
    );
  }

  function ensureHiddenProductUi() {
    ensureCqaUi();
    ensureProductRequestUi();
    document.dispatchEvent(new CustomEvent('verychi:product-hidden-ui-ready'));
  }

  window.__verychiEnsureProductHiddenUi = ensureHiddenProductUi;

  var sizeGuidePromise = null;
  function getDefaultSizeGuideHtml() {
    if (typeof window.__verychiDefaultSizeGuideHtml === 'string' && window.__verychiDefaultSizeGuideHtml) {
      return Promise.resolve(window.__verychiDefaultSizeGuideHtml);
    }
    if (sizeGuidePromise) return sizeGuidePromise;
    if (!config.sizeGuideUrl || !window.fetch) return Promise.resolve('');

    sizeGuidePromise = fetch(config.sizeGuideUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Size guide fragment request failed');
      return response.text();
    }).then(function (html) {
      window.__verychiDefaultSizeGuideHtml = html || '';
      return window.__verychiDefaultSizeGuideHtml;
    }).catch(function () {
      sizeGuidePromise = null;
      return '';
    });

    return sizeGuidePromise;
  }

  window.__verychiGetDefaultSizeGuideHtml = getDefaultSizeGuideHtml;

  var quickAddPromise = null;
  var addToCartSelector = sectionId ? '#AddToCart--' + sectionId : '[id^="AddToCart--"]';
  var addToCartFormId = sectionId ? 'AddToCartForm--' + sectionId : '';
  var interactionSelector = [
    addToCartSelector,
    '#StickyMobileATCBtn',
    '.collection-quick-add-btn',
    '.cqa-desktop-btn',
    '.pp-size-guide-trigger',
    '#ProductSizeGuide',
    '#StickySizeGuide',
    '#CqaSizeGuideTop',
    '.see-look-vpopup__guide-link',
    '.product-request-open-popup',
    '.pp-size-panel__inquiry',
    '.pp-size-panel__option--unavailable',
    '.see-look-vpopup__size--unavailable',
    '.see-look-vpopup__size-notify'
  ].join(', ');

  function loadCollectionQuickAdd() {
    if (!quickAddSrc) return Promise.resolve();
    if (window.__verychiCqaReady) return Promise.resolve();
    if (quickAddPromise) return quickAddPromise;

    quickAddPromise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[data-verychi-cqa]');
      var settled = false;

      function finish() {
        if (settled) return;
        settled = true;
        document.removeEventListener('verychi:cqa-ready', finish);
        resolve();
      }

      function fail() {
        if (settled) return;
        settled = true;
        document.removeEventListener('verychi:cqa-ready', finish);
        quickAddPromise = null;
        if (script && script.parentNode) script.parentNode.removeChild(script);
        reject(new Error('Collection quick-add failed to load'));
      }

      document.addEventListener('verychi:cqa-ready', finish, { once: true });
      if (window.__verychiCqaReady) {
        finish();
        return;
      }

      if (!script) {
        script = document.createElement('script');
        script.src = quickAddSrc;
        script.async = true;
        script.setAttribute('data-verychi-cqa', '');
        document.head.appendChild(script);
      }
      script.addEventListener('error', fail, { once: true });
    });

    return quickAddPromise;
  }

  window.__verychiLoadCollectionQuickAdd = loadCollectionQuickAdd;

  function prepareFromEvent(event) {
    if (!event.target || !event.target.closest || !event.target.closest(interactionSelector)) return;
    ensureHiddenProductUi();
    loadCollectionQuickAdd().catch(function () {});
  }

  document.addEventListener('pointerover', prepareFromEvent, { capture: true, passive: true });
  document.addEventListener('touchstart', prepareFromEvent, { capture: true, passive: true });
  document.addEventListener('focusin', prepareFromEvent, true);

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var matchedInteraction = event.target.closest(interactionSelector);
    if (matchedInteraction) ensureHiddenProductUi();

    var button = event.target.closest('.collection-quick-add-btn, .cqa-desktop-btn');
    if (button && !window.__verychiCqaReady && button.getAttribute('data-cqa-replaying') !== '1') {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      loadCollectionQuickAdd().then(function () {
        button.setAttribute('data-cqa-replaying', '1');
        button.click();
        button.removeAttribute('data-cqa-replaying');
      }).catch(function () {});
      return;
    }

    if (matchedInteraction) loadCollectionQuickAdd().catch(function () {});
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target && (!addToCartFormId || event.target.id === addToCartFormId)) {
      ensureHiddenProductUi();
      loadCollectionQuickAdd().catch(function () {});
    }
  }, true);

  function prefetchSizeGuideWhenIdle() {
    var prefetch = function () { getDefaultSizeGuideHtml().catch(function () {}); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prefetch, { timeout: 2500 });
    } else {
      window.setTimeout(prefetch, 900);
    }
  }

  if (document.readyState === 'complete') {
    prefetchSizeGuideWhenIdle();
  } else {
    window.addEventListener('load', prefetchSizeGuideWhenIdle, { once: true });
  }
})(window, document);
